import { AppCurrentVisits } from '../../../sections/@dashboard/app';
import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useState } from 'react';

export default function UseCasePieChart({ theme, useCases }) {
  const [range, setRange] = useState('month'); // 'month' | 'total'

  const toggle = (
    <ToggleButtonGroup
      value={range}
      exclusive
      onChange={(_, val) => val && setRange(val)}
      size="small"
      sx={{
        '& .MuiToggleButton-root': {
          color: 'white',
          borderColor: 'rgba(255,255,255,0.5)',
          textTransform: 'none',
          px: 1.5,
        },
        '& .MuiToggleButton-root.Mui-selected': {
          backgroundColor: 'rgba(255,255,255,0.9)',
          color: 'primary.main',
          '&:hover': { backgroundColor: 'white' },
        },
      }}
    >
      <ToggleButton value="month">Último mes</ToggleButton>
      <ToggleButton value="total">Total</ToggleButton>
    </ToggleButtonGroup>
  );

  return (
    <AppCurrentVisits
      title="Use Case"
      isCost={false}
      showLabels={true}
      action={toggle}
      chartData={range === 'month' ? useCases.lastMonth : useCases.total}
      chartColors={[
        theme.palette.chart.red[0],
        theme.palette.chart.blue[0],
        theme.palette.chart.violet[0],
        theme.palette.chart.green[0],
        theme.palette.chart.yellow[0],
        theme.palette.chart.violet[3],
      ]}
    />
  );
}

UseCasePieChart.propTypes = {
  theme: PropTypes.any,
  useCases: PropTypes.arrayOf(PropTypes.number),
};
